import get from 'lodash/get';

import content from 'content/content.json';

export const useContent = () => (key) => get(content, key);
